import { mapGetters } from 'vuex';

/**
 * CMS Mixin
 *
 * Contains general methods and computed data to get CMS text outside a template.
 */
export default {
  props: {
    /**
     * The key to retrieve from CMS
     */
    cmsKey: String,
    /**
     * The default value for a given CMS text
     */
    defaultValue: {
      type: String,
      default() {
        return '';
      },
    },
    /**
     * The context for the given CMS text
     */
    context: {
      type: Object,
      default() {
        return {};
      },
    },
    /**
     * The category id to retrieve from CMS
     */
    categoryId: Number,
  },
  computed: {
    ...mapGetters('cmsText', [
      'getCMSText',
    ]),
  },
};
